export default __webpack_public_path__ + "static/media/inovaria.b141c826.png";